import React from 'react'
import { NavLink } from 'react-router-dom'

const Footer = () => {
  return (
    <>
      <footer id='footer'>
        <NavLink to='/about'>About us</NavLink>
      </footer>
    </>
  )
}

export default Footer
